import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { VisationService } from '../../core/services/visation.service';
import { Visation, VisationAction } from '../../core/models/visation.model';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { VisationModalComponent } from '../visation-modal/visation-modal.component';
import { VisationActionService } from '../../core/services/visation-action.service';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { TableComponent } from '../../shared/components/table/table.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TableColumn } from '../../core/models/column.model';

@Component({
  selector: 'app-requester-notification-detail',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatSelectModule,
    MatDialogModule,
    MatNativeDateModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
  ],
  templateUrl: './requester-notification-detail.component.html',
  styleUrls: ['./requester-notification-detail.component.scss'],
})
export class RequesterNotificationDetailComponent implements OnInit {
  visation!: Visation;

  flattenedActionsData: any[] = [];

  // Definir las columnas de la tabla
  tableColumns: TableColumn[] = [
    { header: 'Nº', field: 'id' },
    { header: 'Estado', field: 'actionName' }, // Estado de la acción
    { header: 'Comentario', field: 'observation' }, // Comentario
    { header: 'Fecha', field: 'date', isDate: true }, // Fecha de la acción
    // { header: 'Acciones', field: 'actions', template: 'actionTemplate' }  // Acciones con los botones
  ];

  constructor(
    private route: ActivatedRoute,
    private visationService: VisationService,
    private router: Router,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    const id = +this.route.snapshot.paramMap.get('id')!;
    this.getVisation(id);
  }

  getVisation(id: number): void {
    this.visationService.getVisationById(id).subscribe({
      next: (visation: Visation) => {
        this.visation = visation;
        this.flattenActionsData();
      },
      error: err => {
        console.error('Error fetching visation details:', err);
        this.router.navigate(['/not-found']);
      },
    });
  }

  hasDocuments(): boolean {
    return this.visation.visationActions.some(action => action.filePath);
  }

  createDownloadLink(base64: string): string {
    return `data:application/octet-stream;base64,${base64}`;
  }

  // Método que aplanará los datos para la tabla
  flattenActionsData(): void {
    // Accedemos a las acciones de visation directamente desde this.visation.visationActions
    this.flattenedActionsData = this.visation.visationActions.map((action: VisationAction) => ({
      id: action.id, // Mostrar el número en orden descendente
      actionName: action.action?.name, // Estado o nombre de la acción
      observation: action.observation, // Comentario u observación
      filePath: action?.filePath, // Ruta del archivo
      date: action.createdUtc,
      originalFileName: action?.originalFileName || 'Sin archivo adjunto', // Nombre original del archivo
    }));
  }
}
